"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryService = void 0;
const tslib_1 = require("tslib");
const lists_1 = require("src/lists");
const location_1 = require("src/location");
const BaseLocationService_1 = require("./BaseLocationService");
class CountryService extends BaseLocationService_1.BaseLocationService {
    get serviceName() {
        return 'CountryService';
    }
    constructor(config) {
        super(config);
        this.countryServiceStorageKey = 'countriesInfo';
        this.getDataForSelectOptions = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const [countries, translations] = yield this.getData();
            const result = this.mapItemsToUIModel(countries, translations, BaseLocationService_1.LocationItemToEnum.SelectOptionItem, location_1.CountryApi.COUNTRY_PREFIX);
            if (result) {
                result.sort((0, lists_1.getStringCompareFunction)('title'));
            }
            return result;
        });
        this.getDataForFilterAutoComplete = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const [countries, translations] = yield this.getData();
            const result = this.mapItemsToUIModel(countries, translations, BaseLocationService_1.LocationItemToEnum.FilterAutoCompleteItem, location_1.CountryApi.COUNTRY_PREFIX);
            if (result) {
                result.sort((0, lists_1.getStringCompareFunction)('value'));
            }
            return result;
        });
        this.getData = () => {
            const countriesPromise = this.countryApi
                .loadCountries()
                .then(this.mapCountriesApiDataToLocationInfoModel);
            const translationPromise = this.countryTranslateApi
                .loadTranslatedCountries(this.languageCode)
                .then(this.mapToLocationTranslation)
                .then(this.filterOutInvalidTranslation);
            return Promise.all([countriesPromise, translationPromise]);
        };
        this.getTranslatedCountriesObjectByCountryCode = () => {
            return this.countryTranslateApi
                .loadTranslatedCountries(this.languageCode)
                .then((data) => {
                const translations = data.value;
                return translations.reduce((countriesObject, country) => {
                    countriesObject[country.alpha2] = country.name;
                    return countriesObject;
                }, {});
            });
        };
        this.mapToLocationTranslation = (data) => {
            const translations = data.value;
            return translations.map(item => {
                return { code: item.alpha2, translation: item.name };
            });
        };
        this.mapCountriesApiDataToLocationInfoModel = (data) => {
            const countries = data.value;
            return countries.map((country) => {
                return {
                    code: country.alpha2,
                    name: country.name,
                    region: country.region,
                    subRegion: country.subregion,
                };
            });
        };
        this.countryApi = new location_1.CountryApi({
            storage: sessionStorage,
            storageKey: this.createDefaultStorageKey(this.countryServiceStorageKey),
            url: config.apiUrl,
            locationApiKey: config.locationApiKey,
        });
        this.countryTranslateApi = new location_1.CountryApi({
            storage: sessionStorage,
            storageKey: this.createLocaleStorageKey(this.countryServiceStorageKey),
            url: config.apiUrl,
            locationApiKey: config.locationApiKey,
        });
    }
}
exports.CountryService = CountryService;
